<template>
   <v-container fluid ma-0 pa-0 px-4 >
    <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  Metrics Overview
                </h2>
              </template>
                <span>Metrics Overview</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Metric Dashboards - <span class="font-weight-bold">2</span></h4>
          </v-flex>
          <v-spacer></v-spacer>
          <v-divider vertical ></v-divider>
          <v-flex shrink fill-height class="action">
            <v-tooltip left color="secondary">
                  <v-btn
                icon
                flat
                slot="activator"
                >
                <v-icon color="success" size="24">add_circle</v-icon>
                  </v-btn>
                  <span>Create a new metrics dashboard</span>
                </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
    <v-layout wrap >
      <v-flex xs12 pt-1>
        <v-btn
          :ripple="false" flat
          class="ml-0 mb-2 search-button"
          v-on:click="searchToggled = !searchToggled">
          <v-icon color="secondary" class="mr-2 mt-0">
            {{ searchToggled ? 'close' : 'search' }}
          </v-icon>
          {{ searchToggled ? 'Close search' : 'Search' }}
        </v-btn>
        <v-slide-y-transition>
          <v-layout row wrap class="mt-0" v-if="searchToggled">
            <v-flex
              xs12 sm6 md4
              pt-1 :class="{'pr-0 ': $vuetify.breakpoint.xsAndDown, 'pr-2': $vuetify.breakpoint.smAndUp}">
              <v-text-field
                box clearable
                class="cardcontainer-search-text pa-0 ma-0 body-1"
                v-model="searchTerm"
                @keyup.enter.native="search()"
                label="Search"
                color="secondary"
                clear-icon="cancel">
                <template slot="append">
                  <v-icon>search</v-icon>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex
              xs12 sm6 md4
              pt-1 :class="{'pl-0': $vuetify.breakpoint.xsAndDown, 'pl-2': $vuetify.breakpoint.smAndUp}">
              <v-select
                box clearable
                style="border-bottom:0 !important; "
                class="cardcontainer-order-select pa-0 ma-0 body-1"
                :items="orderByOptions"
                item-text="text"
                item-value="value"
                v-model="orderSelection"
                @change="search()"
                label="Order by"
                color="secondary"
                clear-icon="cancel"
                append-icon="keyboard_arrow_down">
              </v-select>
            </v-flex>
          </v-layout>
        </v-slide-y-transition>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="homepage-card-container card-margin-fix" >
      <v-flex xs12 sm6 md6 lg4 xl3 px-2 mb-2>
        <v-hover>
          <v-card
            color="cardBackground"
            class="pr-4 pl-3 py-2 mb-2 rounded-3"
            slot-scope="{ hover }"
            style="height:78px"
            :class="`elevation-${hover ? 5 : 2}`">
          <router-link class="no-link-style" to="/">
          <v-card-title class="pa-0 pb-1 pt-1">
            <v-flex shrink d-inline-block style="width:65px">
            <v-avatar color="white" size="50px">
                <font-awesome-icon
                  class="secondary--text"
                  size="2x"
                  icon="chart-line">
                </font-awesome-icon>
              </v-avatar>
              </v-flex>
              <v-flex d-inline-block style="width:calc(100% - 90px)">
                <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-0 pb-1 pr-4 ml-0">
                  Metric Dashboard
                </h3>
                  <h4 class="text-truncate pr-0 pb-1 ">
                    <span class="primary--text body-1 opacity-54 pt-1">description</span>
                  </h4>
              </v-flex>
              </v-card-title>
              </router-link>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12 sm6 md6 lg4 xl3 px-2 mb-2>
        <v-hover>
          <v-card
            color="cardBackground"
            class="pr-4 pl-3 py-2 mb-2 rounded-3"
            slot-scope="{ hover }"
            style="height:78px"
            :class="`elevation-${hover ? 5 : 2}`">
          <router-link class="no-link-style" to="/">
          <v-card-title class="pa-0 pb-1 pt-1">
            <v-flex shrink d-inline-block style="width:65px">
            <v-avatar color="white" size="50px">
                <font-awesome-icon
                  class="secondary--text"
                  size="2x"
                  icon="chart-line">
                </font-awesome-icon>
              </v-avatar>
              </v-flex>
              <v-flex d-inline-block style="width:calc(100% - 90px)">
                <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-0 pb-1 pr-4 ml-0">
                  Another Metric Dashboard
                </h3>
                  <h4 class="text-truncate pr-0 pb-1 ">
                    <span class="primary--text body-1 opacity-54 pt-1">description</span>
                  </h4>
              </v-flex>
              </v-card-title>
              </router-link>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import '@/assets/styles/styles.css'
import { mapState } from "vuex"

export default {
  name: 'metrics-overview',
  components: {  },
  computed: {
  
  },
  data: () => ({
   searchToggled: false,
  }),
  watch: {
    searchTerm() { this.search() }
  },
  methods: {
    search() { // And Sort
      let newList = this.caseTypes
      if (this.searchTerm) {
        newList = this.caseTypes.filter((caseType) => caseType.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
      }
      if (this.orderSelection) {
        switch (this.orderSelection) {
          case "name":
            newList = this.orderByName(newList)
            break
          case "createdAt":
            newList = this.orderByCreation(newList)
            break
          default:
            break
        }
      }
      this.orderedTemplates = newList
    },
  }
}
</script>
